module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_787.ca154f01.webp";